import styles from "./UserInput.module.css"
import React from 'react';
import { ChevronDown, ChevronUp, User } from 'lucide-react';
import { useTranslation } from "react-i18next";
import { Subscriber } from "../../../types/auth.types";
import { useDropdown } from "../../../hooks/useDropdown";
import { useUserContext } from "../../../context/UserContext";
/**
* Props for the UserInput component.
*/ 
interface UserInputProps {
    onChange?: (value: number) => void, // Change event handler
    value?: number, // Current value
    users: Subscriber[] | null; // List of options
    className? :string, // Optional additional class
}
/**
* A user input component with label and options.
*
* @param props UserInput props
* @param {(value: number) => void} props.onChange - Change event handler
* @param {number} props.value - Current value
* @param {string} props.className - Optional additional class
* @param {Subscriber[] | null} props.users - List of options
* @returns TSX.Element
*/
const UserInput: React.FC<UserInputProps> = ({ users,  onChange, value, className}) => {
    const { t } = useTranslation(); // Translation
    const { ref, isOpen, setIsOpen } = useDropdown(); // Dropdown hook
    const { userData } = useUserContext();

    const selectedName = (() => {
        const matchedUser = users?.find(u => u.subscriber_id === value);
        if (matchedUser) return matchedUser.name;
        if (userData.id === value) return userData.fullname;
        return t("inputs.user_placeholder");
    })();

    return(
        <>
            <div className={`${styles.UserInputCenter} ${className}`} onClick={()=>setIsOpen(!isOpen)} ref={ref}>
                <div className={styles.UserInputIcon}>
                    <User />
                </div>
                <div className={styles.SelectedUser}><p>{selectedName}</p></div>
                {/*List the given users */}
                {isOpen && (
                    <div className={styles.UserDropdown}>
                        {users !== null && users.map((user, ind)=>(
                            <div 
                            className={styles.UserDropdownItem} 
                            key={ind}
                            onClick ={()=>{
                                onChange && onChange(user.subscriber_id)
                                setIsOpen(false)
                            }}
                            >
                                <p>{user.name}</p>
                            </div>  
                        ))}
                    </div>
                )}
                <button type="button" className={styles.UserDropdownButton} >
                    {isOpen ? <ChevronUp /> : <ChevronDown />}
                </button>
            </div>
        </>
    )
};

export default UserInput;